import { render, staticRenderFns } from "./EmployeeDetailsReport.vue?vue&type=template&id=49a77642"
import script from "./EmployeeDetailsReport.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports